import {
 ListManager, PageHeader, Paginator, Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import manualCastrations from '@/services/api/manualCastrations'
import React from 'react'
import { Link } from 'react-router-dom'
import Row from './Row'
import FilterManualCastrations from './Filter'
// import { Container } from './styles';

function ManualCastrations({ title }) {
  usePageTitle({ title })
  const query = useQuery()
  const { data, loading, error } = useAxiosRequest(manualCastrations.list, query)

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Castrações manuais"
        subtitle="Lista das castrações manuais"
        icon="fas fa-book-medical"
        rightAction={() => (
          <>
            <FilterManualCastrations />
            <Link to="manual-castrations/add" className="btn btn-primary">
              <i className="fas fa-plus" />
              &nbsp;Adicionar
            </Link>
          </>
        )}
      />
      <ListManager
        count={data?.count ?? 0}
        loading={loading}
        error={error}
        emptyIcon="fas fa-book-medical"
        emptySubtitle="Nenhuma castração manual encontrada"
      >
        {
          Boolean(data?.rows) && (
            <>
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Pet</th>
                    <th>Tutor</th>
                    <th>Microchip</th>
                    <th>Castrado em</th>
                    <th className="text-right" width="100px">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {data.rows.map((manualCastration) => (
                    <Row manualCastration={manualCastration} key={manualCastration.id} />
                  ))}
                </tbody>
              </table>
              {
                Boolean(data) && (
                  <div className="my-2">
                    <Paginator paginatedList={data} />
                  </div>
                )
              }
            </>
          )
        }
      </ListManager>
    </Styles.Container>
  )
}

export default ManualCastrations
